import * as React from "react";
import {Button, Modal} from "semantic-ui-react";

interface IProps {
    continueAction: () => void;
    cancelAction: () => void;
    title: string;
    description: string;
}

export class ConfirmationDialog extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);

    }


    public render() {

        return (
            <Modal dimmer={'blurring'} open={true} onClose={this.props.cancelAction} closeOnDimmerClick={false} closeOnDocumentClick={false} closeOnEscape={false}>
                <Modal.Header>{this.props.title}</Modal.Header>
                <Modal.Content image={true}>
                    <Modal.Description>
                        <p>{this.props.description}</p>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        positive={true}
                        content="lanjutkan"
                        onClick={this.props.continueAction}
                    />
                    <Button
                        content="batal"
                        onClick={this.props.cancelAction}
                    />
                </Modal.Actions>
            </Modal>
        );

    }

}


// WEBPACK FOOTER //
// ./src/component/common/ConfirmationDialog.tsx